<template>
    <div
        ref="googleSignInButtonEl"
        class="google-sign-in"
        @click.prevent.stop="emit('click')"
    ></div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useScriptTag } from '@vueuse/core'

import { useCustomerRegistrationInputStore } from '@/composables/useCustomerRegistrationInput'
import { useGoogleSignInId } from '@/plugins/google-sign-in-id'

const emit = defineEmits<{
    submit: []
    fail: []
    click: []
}>()

const googleSignInButtonEl = useTemplateRef('googleSignInButtonEl')

const { googleSignInToken } = storeToRefs(useCustomerRegistrationInputStore())
const client_id = useGoogleSignInId() || ''

useScriptTag(
    'https://accounts.google.com/gsi/client',
    () => {
        if (!googleSignInButtonEl.value) {
            return
        }

        google.accounts.id.initialize({
            use_fedcm_for_button: true,
            client_id,
            callback: (response) => {
                if (response.credential) {
                    googleSignInToken.value = response.credential

                    new Promise(() => emit('submit'))
                        .catch(() => {})
                        .finally(() => {
                            googleSignInToken.value = null
                        })
                } else {
                    emit('fail')
                }
            },
        })
        google.accounts.id.renderButton(googleSignInButtonEl.value, {
            type: 'standard',
            text: 'continue_with',
            shape: 'pill',
            logo_alignment: 'left',
        })
    },
    {
        async: true,
    }
)
</script>

<!-- Attention! Unscoped -->
<style lang="scss">
.google-sign-in {
    width: 100%;
    height: 40px;
    background-color: $white;

    > div {
        width: 100%;
    }

    > div > div {
        width: 100%;
    }

    > div > div > div:first-child {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: 1px solid $slate;

        transition: none !important;

        > div {
            transition: none !important;

            &:hover {
                background-color: $white !important;
                transition: none !important;
            }

            > span {
                font-family: $effra-font-stack !important;
                letter-spacing: 0.05em;
                font-size: 1rem;
                font-weight: 400;
            }
        }
    }

    > div > div > div > div {
        background-color: $white !important;
        &:hover {
            background-color: $white !important;
        }
    }
}
</style>
